import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M7.167 7.333H8v3.5M14.167 8A6.167 6.167 0 1 1 1.833 8a6.167 6.167 0 0 1 12.334 0"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: .167,
		d: "M7.583 5.333a.417.417 0 1 0 .834 0 .417.417 0 0 0-.834 0Z"
	})]
});
export default SvgInfo;
